/**
 * 通用空图标
 */
const EmptyIcon = ({ width = 180, height = 180, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 180 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M73 52H40L24 95H57L73 52Z" fill="#E1E1E4" />
      <path d="M40 52H140L139 130H42L40 52Z" fill="#BBBBBD" />
      <path opacity="0.4" d="M107 52H140L139.67 130H107.66L107 52Z" fill="#E1E1E4" />
      <path d="M107 52H140L156 95H123L107 52Z" fill="#F3F3F4" />
    </svg>
  )
}

export default EmptyIcon
